// Adapts the result of Vite's `import.meta.glob(pattern, { eager: true })` to
// the `require.context` interface that ReactRailsUJS expects (require.context is
// a webpack-only API that Vite does not provide).
//
// ReactRailsUJS calls the context as `reqctx("./" + name)` where `name` is an
// extension-less path such as "ModuleBrick" or "trailmaker/release/index", then
// walks any remaining dotted segments as named exports and finally unwraps
// `default` when the module is flagged `__esModule` (see react_ujs'
// fromRequireContext). It also uses `.keys()` for HMR.
//
// Vite's eager glob hands back a live ES module namespace, which is frozen and
// carries no `__esModule` marker, so react_ujs would never unwrap `default`. We
// copy each namespace into a plain object tagged `__esModule: true` to match
// what webpack + babel produced.
//
// `glob` is the eager glob map (keys are paths relative to the pack that called
// import.meta.glob, e.g. "../components/ModuleBrick.jsx"); `contextDir` is the
// prefix that stands in for require.context's base directory (e.g.
// "../components/").
export default function requireContextFromGlob(glob, contextDir) {
  const normalize = (key) => key.slice(contextDir.length).replace(/\.[jt]sx?$/, '');

  const modulesByName = {};
  for (const key of Object.keys(glob)) {
    modulesByName[normalize(key)] = { ...glob[key], __esModule: true };
  }

  const context = (request) => {
    const name = request.replace(/^\.\//, '').replace(/\.[jt]sx?$/, '');
    const mod = modulesByName[name];
    if (!mod) {
      throw new Error(`Cannot find module '${request}'`);
    }
    return mod;
  };

  context.keys = () => Object.keys(modulesByName).map((name) => `./${name}`);
  context.resolve = (request) => request;
  context.id = contextDir;

  return context;
}
